import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import HomeHero from './components/HomeHero';
import HomeFocus from './components/HomeFocus';
import HomeTodayHot from './components/HomeTodayHot';
import HomeVoices from './components/HomeVoices';
import HomeCommunity from './components/HomeCommunity';
import HomeBrand from './components/HomeBrand';
import HomeFaq from './components/HomeFaq';
import { faqItems } from '@/mocks/gossip';

const schema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爆料吃瓜',
    description: '整理娱乐爆料线索、聚合网友讨论与社群入口的简体中文内容站。',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料吃瓜',
    description: '以网友讨论为基础的娱乐热点整理站点。',
    email: 'contact@baoliaochigua.com',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  },
];

export default function Home() {
  useDocumentMeta({
    title: '爆料吃瓜 - 娱乐热点讨论区与粉丝热议社群入口',
    description:
      '爆料吃瓜聚合娱乐热点线索、讨论区热议与粉丝社群入口，提供时间线、来源标注与证据完整度参考，方便你快速跟进事件进展并参与讨论。',
    keywords: '爆料吃瓜,爆料吃瓜讨论区,爆料吃瓜评论区,爆料吃瓜粉丝热议,爆料吃瓜贴吧,爆料吃瓜群聊',
    path: '/',
    schema,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HomeHero />
        <HomeFocus />
        <HomeTodayHot />
        <HomeVoices />
        <HomeCommunity />
        <HomeBrand />
        <HomeFaq />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}